export default "__VITE_ASSET__28bb04fa__"